import router from '@/router'
import { store } from '@/store'

function goToPath(path) {
  const currentPath = router.currentRoute.path
  if (currentPath !== path) router.push(path)
}

function onDismiss() {
  store.commit('clearError')
}

export { goToPath, onDismiss }
